import React, { useEffect, useState }  from 'react';
import { CardMedia } from '@mui/material'
import useImageProfessional from 'src/Professional/hooks/useImageProfessional';
// import { useSetRecoilState } from 'recoil';
// import { imageProfessionalState, showMoldalImageProfessionalState } from './state/atoms';

const ProfessionalImagenologia = ({
    width = 82,
    height = 120,
    widthIconHeader = 32,
    heightIconHeader = 32,
    image,
    alt,
    rut
}) => {
    // const setShowMoldalImageProfessionalState = useSetRecoilState(showMoldalImageProfessionalState);
    // const setImageProfessional = useSetRecoilState(imageProfessionalState);
    // const handleShowImage = (el) => ev =>  {
    //     setImageProfessional(el)
    //     setShowMoldalImageProfessionalState(true);
    // }

    const { loadImageProfessional } = useImageProfessional();

    const [imagenImg, setImagenImg] = useState();

    useEffect(() => {
        let url = "";

        // let sede = process.env.REACT_APP_SEDE;
        // console.log("SEDE => ",sede);

        // if(sede == 'Puerto Montt'){
            
        //     if(rut.trim() == '108'){
        //         console.log('ECO')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '94') {
        //         console.log('Resonancia')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '86') {
        //         console.log('Mamografía')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '51') {
        //         console.log('Scanner')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
        //         setImagenImg(url);
        //     } else{
        //         console.log('NOSE')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
        //         setImagenImg(url);
        //     }

        // }else{
        //     if(rut.trim() == '19'){
        //         console.log('ECO')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '43') {
        //         console.log('Scanner')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '51') {
        //         console.log('Resonancia')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '78') {
        //         console.log('Mamografía')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '94') {
        //         console.log('Densitometría')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/94.jpg`;
        //         setImagenImg(url);
        //     } else if (rut.trim() == '108') {
        //         console.log('PET-CT')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/108.jpg`;
        //         setImagenImg(url);
        //     }
        //     else{
        //         console.log('NOSE')
        //         url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
        //         setImagenImg(url);
        //     }
        // }

        url = loadImageProfessional(rut);
        setImagenImg(url);

    }, [])

    return (
        <div>
            <CardMedia
                style={{ borderRadius: 5, position: 'sticky' }}
                component="img"
                image={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/icon_medico.png`}
                alt="icono_medico"
                sx={{
                    height: heightIconHeader,
                    width: widthIconHeader
                }}
            />

            <CardMedia
                style={{ borderRadius: 5 }}
                component="img"
                image={imagenImg}
                alt={alt}
                sx={{
                    marginTop: `-${heightIconHeader}px`,
                    height: height,
                    width: width
                }}
            />
        </div>
    )
}

export default ProfessionalImagenologia
